<!-- prettier-ignore -->

<div class="chat-header-container">
    <div class="chat-header-container__title">
        <!-- <img [src]="logoSrc()">
        <span>{{ chatName() }}</span> -->
        <div class="chat-header-container__title__logo-container">
            <img [src]="logoSrc() || '/assets/imgs/chatbot-avatar.png'" style="object-fit: contain;">
            <!-- <icon-avatar></icon-avatar> -->
        </div>
        <span>{{chatName() || 'Cicerone'}}</span>
    </div>
    <div class="chat-header-container__buttons">
        <!-- EMT no icon send conver by email 
        <!--@if(isNew()){
            <icon-mail (click)="toggleAction('email')" />
        }-->
        <!-- <icon-dots (click)="openEventModal()" /> -->
        <icon-reload (click)="resetChat()" />
        <!-- <icon-cicerone (click)="toggleAction('info')" /> -->
        @if(!isFullScreen()){
            <icon-full-screen (click)="toggleFullScreen()" />
        }
        @else {
            <icon-normal-screen (click)="toggleFullScreen()"  />
        }
        <icon-minimize (click)="toggleView()" />


        <!-- <svg (click)="resetChat()" class="chat-header-container__buttons__refresh" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
            <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <svg (click)="toggleView()" class="chat-header-container__buttons__close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" width="30" height="30" fill="#ffffff">
            <path d="M31,25.4L44,12.3c0.6-0.6,0.6-1.5,0-2.1L42,8.1c-0.6-0.6-1.5-0.6-2.1,0L26.8,21.2c-0.4,0.4-1,0.4-1.4,0  L12.3,8c-0.6-0.6-1.5-0.6-2.1,0l-2.1,2.1c-0.6,0.6-0.6,1.5,0,2.1l13.1,13.1c0.4,0.4,0.4,1,0,1.4L8,39.9c-0.6,0.6-0.6,1.5,0,2.1  l2.1,2.1c0.6,0.6,1.5,0.6,2.1,0L25.3,31c0.4-0.4,1-0.4,1.4,0l13.1,13.1c0.6,0.6,1.5,0.6,2.1,0l2.1-2.1c0.6-0.6,0.6-1.5,0-2.1  L31,26.8C30.6,26.4,30.6,25.8,31,25.4z"></path>
        </svg> -->
    </div>
    <div class="opacityEffect opacityEffectStart"></div>

</div>